import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export default function OrderIcon(props) {
    return (
        <SvgIcon style={{"fontSize": props.fontSize}}>
            <svg viewBox="0 0 227.000000 275.000000"
                 preserveAspectRatio="xMidYMid meet">
                <metadata>
                    Created by potrace 1.16, written by Peter Selinger 2001-2019
                </metadata>
                <g transform="translate(0.000000,275.000000) scale(0.100000,-0.100000)"
                   stroke="none">
                    <path d="M344 2651 c-54 -25 -101 -83 -114 -143 -6 -29 -10 -195 -10 -403 l0
-355 50 0 50 0 0 375 0 375 34 38 34 37 126 3 126 4 0 -61 0 -61 -125 0 -125
0 0 -420 0 -420 45 0 45 0 0 375 0 375 84 0 c77 0 85 -2 91 -21 4 -11 21 -29
38 -40 30 -18 56 -19 521 -19 l489 0 38 40 c38 40 39 40 114 40 l75 0 0 -975
0 -975 -725 0 -725 0 0 250 0 250 -45 0 -45 0 0 -295 0 -295 820 0 820 0 0
1065 0 1065 -125 0 -125 0 0 60 0 60 108 0 c126 0 167 -15 194 -70 17 -33 18
-108 18 -1135 0 -1230 5 -1150 -70 -1188 -33 -16 -89 -17 -838 -15 l-804 3
-34 37 -34 38 0 420 0 420 -50 0 -50 0 0 -400 c0 -243 4 -418 11 -448 6 -31
23 -65 45 -90 65 -76 17 -73 951 -70 l831 3 43 30 c23 17 53 50 66 74 l23 44
0 1142 0 1142 -23 44 c-13 24 -43 58 -66 74 l-43 30 -836 2 c-797 3 -839 2
-878 -16z m1336 -165 c0 -76 -3 -95 -16 -100 -9 -3 -218 -6 -464 -6 -520 0
-470 -13 -470 119 l0 81 475 0 475 0 0 -94z"/>
                    <path d="M165 1560 l-90 -90 283 -283 283 -283 127 -42 c70 -23 133 -42 140
-42 7 0 -6 49 -34 133 l-46 132 -282 283 c-154 155 -283 282 -286 282 -3 0
-46 -41 -95 -90z m341 -282 c191 -193 243 -251 252 -281 9 -33 8 -38 -5 -33
-8 3 -20 6 -26 6 -6 0 -125 113 -264 252 l-253 252 22 23 c12 13 24 23 27 23
4 0 115 -109 247 -242z"/>
                </g>
            </svg>
        </SvgIcon>
    )
}